import { Action } from '@ngrx/store';
import { TaskTemplateInterface } from 'app/task/models';
import { TaskInterface } from 'app/task/models/task.model';
import { TaskServiceFilters } from 'app/task/services/task.service';

import { TaskActionType } from 'app/task/state/actions/task-action-type.enum';

export class LoadTasks implements Action {
  public readonly type: TaskActionType = TaskActionType.LoadTasks;

  constructor(public readonly payload?: TaskServiceFilters) { }
}

export class LoadTasksCompleted implements Action {
  public readonly type: TaskActionType = TaskActionType.LoadTasksCompleted;

  constructor(public readonly payload: TaskInterface[]) { }
}

export class LoadTasksFailed implements Action {
  public readonly type: TaskActionType = TaskActionType.LoadTasksFailed;

  constructor(public readonly payload: Error) { }
}

// task templates
export class LoadTaskTemplates implements Action {
  public readonly type: TaskActionType = TaskActionType.LoadTaskTemplates;

  constructor(public readonly payload: any = undefined) { }
}

export class LoadTaskTemplatesCompleted implements Action {
  public readonly type: TaskActionType = TaskActionType.LoadTaskTemplatesCompleted;

  constructor(public readonly payload: TaskTemplateInterface[]) { }
}

export class LoadTaskTemplatesFailed implements Action {
  public readonly type: TaskActionType = TaskActionType.LoadTaskTemplatesFailed;

  constructor(public readonly payload: string) { }
}
